import useDefinedContext from "hooks/useDefinedContext";
import CoachesContext from "../CoachesContext";

function useCoaches() {
  return useDefinedContext(CoachesContext);
}

export default useCoaches;
